<template>
  <item-nav :id="$attrs['id']">
    <item-nav-item :label="$t('layout.nav.admin.seasonNav.overview')" link="seasons" />
    <item-nav-group v-if="!isEmpty(seasons)" :open="true" :label="$t('layout.nav.admin.seasonNav.ratePlanSeasons')">
      <item-nav-group-item v-for="season in seasons"
                           v-if="!season.deleted && season.ratePlanType === 'DayRate'"
                           :label="getName(season.name)"
                           :params="routeParams(season.id)"
                           :key="season.id"
                           link="season" />
    </item-nav-group>
    <item-nav-group v-if="hasLicense('Packages') && !isEmpty(seasons)" :open="true" :label="$t('layout.nav.admin.seasonNav.packageSeasons')">
      <item-nav-group-item v-for="season in seasons"
                           v-if="!season.deleted && season.ratePlanType === 'Package'"
                           :label="getName(season.name)"
                           :params="routeParams(season.id)"
                           :key="season.id"
                           link="season" />
    </item-nav-group>
    <item-nav-group v-if="!isEmpty(deletedSeasons)" :open="false" :label="$t('layout.nav.admin.seasonNav.deletedSeasons')">
      <item-nav-group-item v-for="season in deletedSeasons"
                           :label="getName(season.name)"
                           :params="routeParams(season.id)"
                           :key="season.id"
                           link="season" />
    </item-nav-group>

  </item-nav>
</template>

<script>

import { cloneDeep, isNil, isEmpty, sortBy } from 'lodash';
import ItemNavGroup from '../ItemNavGroup';
import ItemNavGroupItem from '../ItemNavGroupItem';
import HotelmeisterMixin from '../../../../../mixins/HotelmeisterMixin';

export default {
  name: 'SeasonNav',
  components: { ItemNavGroupItem, ItemNavGroup },

  mixins: [HotelmeisterMixin],
  props: [],

  data() {
    return {
      seasons: [],
    };
  },

  computed: {
    deletedSeasons: function () {
      return this.seasons.filter(it => it.deleted === true);
    },
  },

  created: function () {
    this.axios.get(this.serviceUrls.season.list(this))
      .then((response) => {
        this.seasons = sortBy(response.data.data, ['sort', `name.${this.hotelSettings.details.primaryLanguage}`]);
      });

    this.$serviceBus.$on('season.list', (data) => {
      if (isNil(data)) {
        this.axios.get(this.serviceUrls.season.list(this))
          .then((response) => {
            this.seasons = sortBy(response.data.data, ['sort', `name.${this.hotelSettings.details.primaryLanguage}`]);
          });
      } else {
        this.seasons = data;
      }
    });
  },

  mounted: function () {
    this.$emit('widenav', true);
  },

  methods: {
    getName(name) {
      if (isNil(name)) return '-';
      let ret = null;

      ret = name[this.$shortLocale] || name[this.hotelSettings.details.primaryLanguage];

      if (!isEmpty(ret)) return ret;

      return name[this.hotelSettings.details.primaryLanguage];
    },
    routeParams(seasonId) {
      return {
        seasonId: seasonId,
      };
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
  // @import '~styles/main';
</style>



// WEBPACK FOOTER //
// src/components/lib/layout/nav/admin/SeasonNav.vue